import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from '../config/firebase';
import { logError, logInfo } from './logger';

export const uploadProfileImage = async (userId, file) => {
  try {
    if (!file || !userId) {
      throw new Error('Missing required parameters for upload');
    }

    // Validate file type
    if (!file.type.startsWith('image/')) {
      throw new Error('Only image files are allowed');
    }

    // Validate file size (max 5MB)
    const MAX_SIZE = 5 * 1024 * 1024;
    if (file.size > MAX_SIZE) {
      throw new Error('Image size must be less than 5MB');
    }

    // Create storage reference
    const storageRef = ref(storage, `profile-images/${userId}/${Date.now()}_${file.name}`);

    // Upload file
    const snapshot = await uploadBytes(storageRef, file);
    logInfo('Profile image uploaded to storage');

    // Get download URL
    const url = await getDownloadURL(snapshot.ref);
    logInfo('Profile image URL retrieved');

    return url;
  } catch (error) {
    logError('Profile image upload failed:', error);
    throw new Error(error.message || 'Failed to upload profile image');
  }
};

export const generateUserId = () => {
  const timestamp = Date.now().toString(36);
  const randomStr = Math.random().toString(36).substring(2, 8);
  return `${timestamp}-${randomStr}`.toUpperCase();
};